function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  filter: "url(#arrows_svg__filter0_d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.531 7.03a.75.75 0 00-1.06 0l-4.117 4.116a.5.5 0 00.354.854h2.293v12.5a.5.5 0 00.5.5h3a.5.5 0 00.5-.5V12h2.293a.5.5 0 00.353-.854L11.531 7.03z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19 18V5.5a.5.5 0 01.5-.5h3a.5.5 0 01.5.5V18h2.294a.5.5 0 01.353.854l-4.116 4.116a.75.75 0 01-1.06 0l-4.116-4.116a.5.5 0 01.353-.854h2.293z",
  fill: "url(#arrows_svg__paint0_linear)"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "arrows_svg__paint0_linear",
  x1: 18.005,
  y1: 5,
  x2: 25.764,
  y2: 5.935,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})), /*#__PURE__*/React.createElement("filter", {
  id: "arrows_svg__filter0_d",
  x: -2,
  y: -2,
  width: 36,
  height: 36,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.237656 0 0 0 0 0.293125 0 0 0 0 0.3375 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

var SvgArrows = function SvgArrows(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgArrows;